<mat-form-field class="timepicker">
  <input
    matInput
    [format]="format()"
    [formControl]="control"
    [max]="maxTime()!"
    [min]="minTime()!"
    [ngxMatTimepicker]="timePicker"
    placeholder="hh:mm"
    readonly
  />
  <ngx-mat-timepicker-toggle matSuffix class="text-primary" (click)="timePicker.open()" />

  @if (control && control.errors) {
    <mat-error class="font-12 text-danger">
      {{ control.errors | validationHandler }}
    </mat-error>
  }
</mat-form-field>

<ngx-mat-timepicker color="primary" [appendToInput]="true" #timePicker />
